module.exports = __webpack_public_path__ + "static/media/port.653a74a6.svg";